import orgamax from 'ampersand-app'
import { FineUploaderBasic as Uploader } from 'fine-uploader'

export const uploadFile = (endpoint, blob, postData = null) => {
  return new Promise((resolve, reject) => {
    const uploader = new Uploader({
      autoUpload: false,
      multiple: false,
      callbacks: {
        onError: (id, name, reason, xhr) => {
          const error = new Error(reason)
          error.statusCode = xhr.status

          try {
            error.body = JSON.parse(xhr.responseText)
          } catch (error) {
            error.body = xhr.response
          }

          error.xhr = xhr
          reject(error)
        },
        onComplete: (id, name, response, xhr) => resolve({ body: response }),
      },
      request: {
        endpoint,
        customHeaders: { Authorization: `Bearer ${orgamax.user.token}` },
        inputName: 'file',
        requireSuccessJson: false,
      },
    })

    if (postData) {
      uploader.setParams(postData)
    }
    uploader.addBlobs([{ name: 'newletterPaper', blob }])
    uploader.uploadStoredFiles()
  })
}
